import React, { useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { setLoader } from '../../../Redux/features/LoaderSlice';
import axiosInstance from 'Utils/Interceptor';
import CustomModal from 'Components/Modal/CustomModal';

const UploadImageFile = ({ setFileURL }) => {
  const [fileName, setFileName] = useState(null);
  const fileInputRef = useRef(null);
  const [filePreviewURL, setFilePreviewURL] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false); // Add state for delete confirmation
  const dispatch = useDispatch();

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFileName(e.target.files[0].name);
      const file = e.target.files[0];
      // Set file preview URL
      const previewURL = URL.createObjectURL(file);
      setFilePreviewURL(previewURL);
      uploadImage(e.target.files[0]);
    }
  };

  const uploadImage = async (imageFile) => {
    const formData = new FormData();
    formData.append('file', imageFile);
    formData.append('type', 'prescription');
    dispatch(setLoader(true));
    try {
      const response = await axiosInstance.post(
        '/api/user/uploadimage',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );

      setFileURL(response?.data?.data);
    } catch (error) {
      // Handle the error here if needed
      console.error(error);
    } finally {
      dispatch(setLoader(false));
    }
  };

  const openModal = () => {
    if (filePreviewURL) {
      setModalOpen(true); // Always open the modal for both images and PDFs
    }
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const clearFile = () => {
    setFileName(null);
    setFileURL(null); // Clear the uploaded file URL
    fileInputRef.current.value = ''; // Reset the file input
  };

  const viewFile = () => {
    if (filePreviewURL) {
      window.open(filePreviewURL, '_blank'); // Open in a new tab
    }
  };

  return (
    <div className="image-upload">
      <div className="form-group">
        <button
          type="button"
          className="btn btn-md"
          onClick={() => fileInputRef.current.click()}
          disabled={!!fileName} // Disable after upload
        >
          <span>Upload Prescription</span>
        </button>
      </div>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/jpeg,image/png,application/pdf"
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
      {fileName && (
        <div className="prescription-upload-wrapper">
          <div className="prescription-text">{fileName}</div>
          <div className="prescription-view" style={{ minWidth: '185px' }}>
            <button
              onClick={openModal}
              className="btn btn-small"
            >
              <span>View</span>
            </button>
            <button
              onClick={() => setShowDeleteConfirm(true)}
              className="btn btn-small btn-danger"
              style={{ marginLeft: '8px' }}
            >
              <span>Delete</span>
            </button>
          </div>
        </div>
      )}
      {/* Delete Confirmation Modal */}
      {showDeleteConfirm && (
        <CustomModal
          onClose={() => setShowDeleteConfirm(false)}
          show={showDeleteConfirm}
          size="lg"
        >
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <h3>Are you sure you want to delete this file?</h3>
            <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
              <button
                className="btn btn-small btn-danger"
                onClick={() => {
                  clearFile();
                  setShowDeleteConfirm(false);
                }}
              >
                <span>Yes</span>
              </button>
              <button
                className="btn btn-small"
                onClick={() => setShowDeleteConfirm(false)}
              >
                <span>No</span>
              </button>
            </div>
          </div>
        </CustomModal>
      )}
      <p className="accepted-files">Accepted file types: JPEG, PNG, PDF</p>
      {/* Modal for Preview */}
      {isModalOpen && (
        <CustomModal
          onClose={closeModal}
          removeHeader={true}
          show={isModalOpen}
          size="full"
        >
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(0, 0, 0, 0.7)', // darker overlay
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 1000
            }}
            onClick={closeModal}
          >
            <div
              style={{
                background: '#fff',
                padding: '20px',
                borderRadius: '12px',
                width: '98vw', // nearly full viewport width
                maxWidth: '1600px', // much larger max width
                maxHeight: '96vh', // nearly full viewport height
                position: 'relative',
                overflow: 'auto',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                boxShadow: '0 8px 40px rgba(0,0,0,0.3)'
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={closeModal}
                className="btn-close"
                aria-label="Close"
                style={{ position: 'absolute', top: -1, right: 10, zIndex: 2 }}
              ></button>
              {filePreviewURL && fileName && fileName.toLowerCase().endsWith('.pdf') ? (
                <iframe
                  src={filePreviewURL}
                  title="PDF Preview"
                  width="100%"
                  height="900px"
                  style={{ border: 'none', minHeight: '80vh' }}
                />
              ) : (
                <img
                  src={filePreviewURL}
                  alt="Preview"
                  style={{ maxWidth: '100%', maxHeight: '90vh', objectFit: 'contain' }}
                />
              )}
            </div>
          </div>
        </CustomModal>
      )}
    </div>
  );
};

export default UploadImageFile;
